/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState, useMemo } from 'react';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import ApiService from '@services/api';
import { useSession } from '@hooks/useSession';
import settingsStore from '@store/SettingsStore';
import { MdRefresh, MdOutlineCancel, MdRemoveRedEye } from 'react-icons/md';

import Loading from '@components/Loading';
import RoundButton from '@components/RoundButton';
import NotAuthenticated from '@components/NotAuthenticated';
import SelectInput from '@components/SelectInput';
import Button from '@components/Button';
import Paginator from '@components/Paginator';
import Modal from '@components/Modal';
import { StatusColor } from '@styles/colors';

import {
  Container,
  Title,
  Selection,
  Buttons,
  Table,
  Actions,
  ContainerStatus,
  Status,
  FilterInputs,
} from './styles';

interface IEmailLog {
  id: string;
  dfeType: string;
  dfeId: string;
  recipient: string;
  status: string;
  errorDetails?: string;
  scheduledFor?: string;
  createdAt: string;
}

const StatusEmail = {
  PENDING: { name: 'Pendente', color: StatusColor.pending },
  FAILED: { name: 'Falhou', color: StatusColor.failed },
  COMPLETED: { name: 'Concluído', color: StatusColor.completed },
  CANCELLED: { name: 'Cancelado', color: StatusColor.cancelled },
};

const EmailLogs: React.FC = observer(() => {
  const params = useParams();
  const { isMigrating } = useSession();
  const { api } = new ApiService(params.token);

  const statusOptions = useMemo(() => {
    return [
      { label: 'Todos', value: '' },
      { label: 'Pendente', value: 'pending' },
      { label: 'Concluído', value: 'completed' },
      { label: 'Falhou', value: 'failed' },
      { label: 'Cancelado', value: 'cancelled' },
    ];
  }, []);

  const dfeTypeOptions = useMemo(() => {
    return [
      { label: 'Todos', value: '' },
      { label: 'NF-e', value: 'nfe' },
      { label: 'NFC-e', value: 'nfce' },
      { label: 'CT-e', value: 'cte' },
      { label: 'MDF-e', value: 'mdfe' },
    ];
  }, []);

  const [statusSel, setStatusSel] = useState(statusOptions[0]);
  const [dfeTypeSel, setDfeTypeSel] = useState(dfeTypeOptions[0]);

  const [loading, setLoading] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [records, setRecords] = useState<IEmailLog[]>([]);
  const [page, setPage] = useState(1);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const isEmailValidationError = (errorDetails?: string) => {
    if (!errorDetails) return false;
    const err = errorDetails.toLowerCase();
    return (
      err.includes('inválido') ||
      err.includes('não existe') ||
      err.includes('não possui servidor') ||
      err.includes('não encontrado')
    );
  };
  const [totalRecords, setTotalRecords] = useState(100);
  const [queryCount, setQueryCount] = useState(0);

  useEffect(() => {
    if (!isMigrating) {
      loadRecords();
    }
  }, [page, isMigrating]);

  async function loadRecords() {
    try {
      setLoading(true);

      const queryParams: any = {
        page,
        limit: 20,
      };

      if (statusSel.value !== '') {
        queryParams.status = statusSel.value;
      }

      if (dfeTypeSel.value !== '') {
        queryParams.type = dfeTypeSel.value;
      }

      const resp = await api.get('/email-logs', {
        params: queryParams,
      });
      setRecords(resp.data.items);
      setTotalRecords(resp.data.total);
      setQueryCount(resp.data.queryCount);
      setAuthenticated(true);
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        setAuthenticated(false);
      } else {
        toast.error('Falha ao carregar o histórico de e-mails');
      }
    } finally {
      setLoading(false);
    }
  }

  async function handleResend(id: string) {
    try {
      await api.post(`/email-logs/${id}/resend`);
      toast.success('Reenvio agendado com sucesso!');
      loadRecords();
    } catch (error: any) {
      toast.error('Falha ao agendar reenvio');
    }
  }

  async function handleCancel(id: string) {
    try {
      await api.post(`/email-logs/${id}/cancel`);
      toast.success('Envio cancelado com sucesso!');
      loadRecords();
    } catch (error: any) {
      toast.error(error.response?.data?.error || 'Falha ao cancelar envio');
    }
  }

  if (loading && records.length === 0)
    return (
      <Container>
        <Loading />
      </Container>
    );

  if (!authenticated) {
    return <NotAuthenticated />;
  }

  return (
    <Container>
      <Title>HISTÓRICO DE E-MAILS</Title>
      <Selection>
        <FilterInputs>
          <label>
            Tipo DF-e
            <SelectInput
              fullWidth
              options={dfeTypeOptions}
              defaultValue={dfeTypeOptions[0]}
              value={dfeTypeSel}
              onChange={(newValue: any) => setDfeTypeSel(newValue)}
            />
          </label>
          <label>
            Status
            <SelectInput
              fullWidth
              options={statusOptions}
              defaultValue={statusOptions[0]}
              value={statusSel}
              onChange={(newValue: any) => setStatusSel(newValue)}
            />
          </label>
        </FilterInputs>

        <Buttons>
          <Button
            onClick={() => {
              setPage(1);
              loadRecords();
            }}
          >
            Consultar
          </Button>
        </Buttons>
      </Selection>
      <p style={{ marginTop: 10, marginBottom: 10 }}>
        *Os e-mails enviados vão para uma fila de processamento e podem levar
        alguns minutos para serem enviados. Aqui é possível visualizar o
        histórico de e-mails dos últimos 30 dias.
      </p>
      {records.length > 0 && (
        <>
          <Table>
            <thead>
              <tr>
                <th>Data/Hora de Inclusão</th>
                <th>Tipo DF-e</th>
                <th>E-mail</th>
                <th>Status</th>
                {settingsStore.email?.limitPerHour && (
                  <th>Data/Hora de Previsão</th>
                )}
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {records.map((record) => (
                <tr key={record.id}>
                  <td>
                    {format(new Date(record.createdAt), 'dd/MM/yyyy HH:mm:ss')}
                  </td>
                  <td>{record.dfeType.toUpperCase()}</td>
                  <td>{record.recipient}</td>
                  <td>
                    <ContainerStatus>
                      <Status
                        style={{
                          backgroundColor:
                            StatusEmail[
                              record.status.toUpperCase() as keyof typeof StatusEmail
                            ]?.color || '#333',
                        }}
                      >
                        {StatusEmail[
                          record.status.toUpperCase() as keyof typeof StatusEmail
                        ]?.name || record.status}
                      </Status>
                      {record.status === 'failed' && record.errorDetails && (
                        <RoundButton
                          hint="Visualizar Erro"
                          style={{ marginLeft: 5 }}
                          onClick={() =>
                            setErrorMessage(record.errorDetails || null)
                          }
                        >
                          <MdRemoveRedEye size={18} />
                        </RoundButton>
                      )}
                    </ContainerStatus>
                  </td>
                  {settingsStore.email?.limitPerHour && (
                    <td>
                      {record.scheduledFor
                        ? format(
                            new Date(record.scheduledFor),
                            'dd/MM/yyyy HH:mm:ss'
                          )
                        : '-'}
                    </td>
                  )}
                  <td>
                    <Actions>
                      {(record.status === 'failed' ||
                        record.status === 'cancelled') &&
                        !isEmailValidationError(record.errorDetails) && (
                          <RoundButton
                            hint="Reenviar"
                            onClick={() => handleResend(record.id)}
                          >
                            <MdRefresh size={18} />
                          </RoundButton>
                        )}
                      {record.status === 'pending' && (
                        <RoundButton
                          hint="Cancelar"
                          onClick={() => handleCancel(record.id)}
                        >
                          <MdOutlineCancel size={24} />
                        </RoundButton>
                      )}
                    </Actions>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div>
            Exibindo {page > 1 ? (page - 1) * 20 + 1 : 1} a{' '}
            {page > 1 ? (page - 1) * 20 + queryCount : queryCount} de um total
            de {totalRecords} registros.
          </div>
        </>
      )}
      {records.length === 0 && !loading && (
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          Nenhum e-mail encontrado.
        </div>
      )}
      <Paginator
        activePage={Number(page)}
        limitPage={20}
        totalRecords={totalRecords}
        onChange={(newPage) => setPage(newPage)}
      />
      {errorMessage && (
        <Modal onCloseRequest={() => setErrorMessage(null)} exitButton={false}>
          <div style={{ padding: 40 }}>{errorMessage}</div>
        </Modal>
      )}
    </Container>
  );
});

export default EmailLogs;
